import { Link } from '@tanstack/react-router'
import { ArrowUpRight } from 'lucide-react'
import { DURUM_ETIKETI } from '../icerik/moduller'
import type { Modul } from '../icerik/tipler'
import { Rozet, cn } from './ui'

export function ModulKarti({ modul, className }: { modul: Modul; className?: string }) {
  const Ikon = modul.ikon
  const rozet = DURUM_ETIKETI[modul.durum]
  return (
    <Link
      to={`/ozellikler/${modul.slug}`}
      className={cn(
        'group relative flex h-full flex-col rounded-[var(--radius-panel)] bg-surface p-5 ring-soft transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5',
        className,
      )}
    >
      <div className="flex items-start justify-between">
        <span className="grid size-10 place-items-center rounded-[var(--radius-card)] bg-brand-subtle text-brand transition-colors group-hover:bg-brand group-hover:text-on-brand">
          <Ikon className="size-5" />
        </span>
        <ArrowUpRight
          className="size-4 text-ink-3 opacity-0 transition-opacity group-hover:opacity-100"
          aria-hidden
        />
      </div>
      <p className="mt-4 flex flex-wrap items-center gap-2 text-[15px] font-semibold text-ink">
        {modul.ad}
        {rozet && <Rozet tone="warning">{rozet}</Rozet>}
        {modul.grup === 'paket' && <Rozet tone="brand">Paket</Rozet>}
      </p>
      <p className="mt-1.5 text-sm leading-relaxed text-ink-2">{modul.kisa}</p>
    </Link>
  )
}
